import type { ReactNode } from 'react';
import { type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import { ToggleField } from '@/components/ui/switch';

/** Interruptor com rótulo e explicação, ligado ao React Hook Form. */
export function SwitchField<
  T extends FieldValues,
  N extends FieldPath<T>,
  TOut extends FieldValues = T,
>({
  control,
  name,
  label,
  description,
  disabled,
  className,
}: {
  control: Control<T, unknown, TOut>;
  name: N;
  label: string;
  description?: ReactNode;
  disabled?: boolean;
  className?: string;
}) {
  const { field } = useController({ control, name });
  return (
    <ToggleField
      label={label}
      description={description}
      checked={Boolean(field.value)}
      onCheckedChange={field.onChange}
      disabled={disabled}
      className={className}
    />
  );
}
